App.Modules.Panel = class Panel extends PF.Widget
	{

	static get options()
		{
		return {};
		}

	init()
		{
		super.init();

		this.dom.load(this.template, 'panel');

		PF.Dom.Node.findOne('#app').prepend(this.dom.panel);

		this.panel = app.f7.panel.create({
			el: this.dom.panel.node,
			// resizable: true,
			// swipe: true,
			visibleBreakpoint: 1024,
			collapsedBreakpoint: 768,
		});


		if (app.user != null)
			{
			let navbarMain = new NavbarMain();

			this.dom.load(navbarMain.templates, 'navbarMain');

			this.dom.profileName.bindText();
			this.dom.profileName.text = app.user.lname;
			this.dom.profileRole.bindText();
			this.dom.profileRole.text = app.user.permissions[app.user.role.name].description;

			let navbarInner = PF.Dom.Node.findOne('#app');
			navbarInner.prepend(this.dom.navbarMain);
			}


		this.panel.on('breakpoint', () => this.manageClass());
		this.manageClass();

		this.collapseState = false;
		this.dom.menuButton.on('click', () => {
			let newVisibleBreakpoint = 0;
			if (768 <= PF.Dom.Node.findOne('#app').width() && PF.Dom.Node.findOne('#app').width() <= 1024)
				{
				newVisibleBreakpoint = 768;
				}
			else if (PF.Dom.Node.findOne('#app').width() > 1024)
				{
				newVisibleBreakpoint = 5000;
				}
			if (this.collapseState == false)
				{
				this.collapseState = true;
				this.panel.params.visibleBreakpoint = newVisibleBreakpoint;
				}
			else
				{
				this.collapseState = false;
				this.panel.params.visibleBreakpoint = 1024;
				}
			this.panel.visibleBreakpointResizeHandler();
			this.panel.collapsedBreakpointResizeHandler();
		});
		}

	manageClass()
		{
		if (PF.Dom.Node.findOne('#app').width() >= 1024)
			{
			// PF.Dom.Node.findOne('#app').addClass('has-left-panel');
			}
		else
			{
			// PF.Dom.Node.findOne('#app').removeClass('has-left-panel');
			}
		}

	destroy()
		{
		// this.f7panel.destroy();
		if (app.f7.panel.left !== undefined)
			{
			app.f7.panel.left.destroy();
			}
		if (this.dom.panel !== undefined)
			{
			this.dom.panel.remove();
			}
		if (PF.Dom.Node.findOne('#navbarMain').node !== undefined)
			{
			PF.Dom.Node.findOne('#navbarMain').remove();
			}
		// PF.Dom.Node.findOne('.panel-backdrop').remove();
		PF.Dom.Node.findOne('#viewMain').css('margin-left', '0px');
		app.panel = undefined;
		// app.off('change:currentPage', this.changePageSlot, this);
		}


	};

class NavbarMain
	{
	get templates()
		{
		//language=HTML
		return /*html*/`
		  <div class="navbar" id="navbarMain" style="z-index: 9900;">
			  <div class="navbar-bg"></div>
			  <div class="navbar-inner">
				  <!-- <div class="left">Left</div> -->
				  <div class="left">
					  <a href="#" class="link " pf="menuButton">
						  <i class="material-icons">menu</i>
					  </a>
				  </div>
				  <div class="title">Статистика по эмоциям</div>
				  <div class="right" style="display: flex;  font-size: 16px;">
					  <!-- <a href="/notices" class="link" style="display: flex;align-items:center; padding:8px">
						  <i class="material-icons">notifications</i>
						  <div class="item-after" style="display: none" pf="newNoticeBadge">
							  <span class="badge color-deeppurple" pf="noticeCount"></span>
						  </div>
					  </a> -->
					  <a href="/profile" class="link" style="display: flex; align-items: center">
						  <i class="material-icons" style="padding-right: 16px">person</i>
						  <div style="line-height: 1.4em">
							  <div pf="profileName" style="font-weight: bold"></div>
							  <div pf="profileRole" style="color:var(--ct-g);font-size: 14px"></div>
						  </div>
					  </a>
				  </div>
			  </div>
		  </div>
		`;
		}

	onRender()
		{

		}

	}